export default "/images/96985dd44f8c7e7e1d852111e3448a6b.avif";